import {
  Col,
  Row,
  DatePicker,
  Card,
  message,
  Spin,
  Tooltip,
  Tag,
  Button,
} from "antd";
import React, { useEffect, useMemo, useState } from "react";
import MotionHoc from "../../../utils/MotionHoc";
import {
  baseUrl,
  GET_JOB_IN_PROGRESS_BY_STATUS,
  HEADERS_EXPORT,
  HEADERS_EXPORT_BEN,
  POST_LOAN_DB2,
} from "../../API/apiUrls";
import ReactECharts from "echarts-for-react";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import {
  BarChartOutlined,
  CalendarOutlined,
  CheckCircleOutlined,
  InboxOutlined,
  CloseCircleOutlined,
  ClockCircleOutlined,
  FileProtectOutlined,
  CheckOutlined,
} from "@ant-design/icons";

//use redux
import axios from "axios";
import DateCustom from "../../../hook/DateCustom";
import dayjs from "dayjs";
import CurrencyFormat from "../../../hook/CurrencyFormat";
import DataCheck from "./modal/DataCheck";
import {
  BAD_DEBTOR,
  FINISH,
  INDICT,
  TIMEOUT,
  WITHDRAW_CASE,
} from "../../../utils/constant/StatusConstant";

const Main = () => {
  const [
    currencyFormat,
    currencyFormatComma,
    currencyFormatPoint,
    currencyFormatNoPoint,
  ] = CurrencyFormat();
  const [convertDateThai, convertDateThaiShort] = DateCustom();
  const [loading, setLoading] = useState();
  const ROLE_ID = localStorage.getItem("ROLE_ID");
  const userId = parseInt(localStorage.getItem("USER_ID"));
  const userCompany = localStorage.getItem("COMPANY_ID");
  const [arrow, setArrow] = useState("Show");
  const [cancelData, setCancelData] = useState([]);
  const [arrData, setArrData] = useState();
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [isModalCheckData, setIsModalCheckData] = useState(false);
  const [statusData, setStatusData] = useState();
  const [isActive, setIsActive] = useState(false);
  const [contnos, setContnos] = useState({});
  const [dataContnos, setDataContnos] = useState();

  const mergedArrow = useMemo(() => {
    if (arrow === "Hide") {
      return false;
    }
    if (arrow === "Show") {
      return true;
    }
    return {
      pointAtCenter: true,
    };
  }, [arrow]);

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    BarChart();
  }, [cancelData]);

  const loadData = async () => {
    setLoading(true);

    try {
      const response = await axios.get(
        baseUrl + GET_JOB_IN_PROGRESS_BY_STATUS + INDICT,
        {
          headers: HEADERS_EXPORT,
        },
      );
      if (response.data) {
        if (response.data) {
          console.log(response.data);

          filterDataLawyer(response.data);

          setLoading(false);
        }
      }
    } catch (error) {
      console.error(
        "Error posting data:",
        error.response ? error.response.data : error.message,
      );
      setLoading(false);
      message.error(`ไม่พบข้อมูล`);
    }
  };

  const filterDataLawyer = (data) => {
    if (Array.isArray(data)) {
      // ✅ กรอง Role (Admin & ทนาย)
      const newData = data.filter(
        (item) =>
          ROLE_ID === "1" ||
          ROLE_ID === "3" ||
          ROLE_ID === "2" ||
          ROLE_ID === "8",
      );

      setArrData(newData);

      let groupedByLawyer = {};

      newData.forEach((item) => {
        const lawyerName = item.LAWYER_NNAME || "ไม่ระบุทนาย";

        // สร้างกลุ่มข้อมูลสำหรับทนายแต่ละคน
        if (!groupedByLawyer[lawyerName]) {
          groupedByLawyer[lawyerName] = {
            all: [], // ทั้งหมด
            waitLawsuit: [], // รอฟ้อง (ไม่มีเลขคดี)
            withBackCase: [], // มีเลขคดีดำ + วันนัด
            withRedCase: [], // มีเลขคดีแดง
            ageeement: [], // ยอมความ - MAIN_STATUS_ID === 5
            judgement: [], // ตัดสิน (ถ้ามี)
            finish: [], // MAIN_STATUS_ID === 11
            withdrawCase: [], // MAIN_STATUS_ID === 13
          };
        }

        // 1️⃣ ข้อมูลทั้งหมด
        groupedByLawyer[lawyerName].all.push(item);

        // 2️⃣ ตรวจสอบคดีจบ - ถ้าจบแล้วไม่ต้อง push ที่อื่น
        if (item.trial_money_cleared_status === 4) {
          groupedByLawyer[lawyerName].finish.push(item);
          return; // ❌ ถ้าจบแล้ว ไม่ซ้ำกลุ่มอื่น
        }

        // 3️⃣ ตรวจสอบคดียอมความ - ถ้ายอมความแล้วไม่ต้อง push ที่อื่น
        if (item.trial_money_cleared_status === 2) {
          groupedByLawyer[lawyerName].ageeement.push(item);
          return; // ❌ ถ้ายอมความแล้ว ไม่ซ้ำกลุ่มอื่น
        }

        // 4️⃣ ตรวจสอบคดีถอน - push ทั้ง withdrawCase และกลุ่มอื่น
        if (item.MAIN_STATUS_ID === 13) {
          groupedByLawyer[lawyerName].withdrawCase.push(item);
          // ✅ ไม่ return ให้ไปต่อเพื่อ push กลุ่มอื่นด้วย
        }

        // 5️⃣ แยกตามสถานะคดี
        if (item.red_case_number) {
          // มีเลขคดีแดง
          groupedByLawyer[lawyerName].withRedCase.push(item);
        } else if (item.black_case_number && item.consideration_date) {
          // มีเลขคดีดำ + วันนัด
          groupedByLawyer[lawyerName].withBackCase.push(item);
        } else if (
          !item.black_case_number &&
          !item.consideration_date &&
          !item.red_case_number
        ) {
          // รอฟ้อง (ไม่มีเลขคดีใดๆ)
          groupedByLawyer[lawyerName].waitLawsuit.push(item);
        }
      });

      console.log("groupedByLawyer", groupedByLawyer);
      setCancelData(groupedByLawyer);
    } else {
      console.error("data is not an array or is undefined");
    }
  };

  const loadDataReport = async (data) => {
    console.log(data);
    setLoading(true);

    try {
      const response = await axios.post(POST_LOAN_DB2, data, {
        headers: HEADERS_EXPORT_BEN,
      });
      if (response.data) {
        if (response.data) {
          console.log(response.data);
          setDataContnos(response.data);
          setLoading(false);
        }
      }
    } catch (error) {
      console.error(
        "Error posting data:",
        error.response ? error.response.data : error.message,
      );
      setLoading(false);
      message.error(`ไม่พบข้อมูลรายงาน`);
    }
  };

  const BarChart = () => {
    // ✅ 1) ใช้ Object.keys แทน map()
    const lawyerNames = Object.keys(cancelData).filter(Boolean);
    console.log("cancelData", cancelData);

    // ✅ 2) สร้าง chartData ตาม lawyerNames ที่หาได้
    const chartData = [
      [
        "ทนาย",
        "ทั้งหมด",
        "รอฟ้อง",
        "STATUS=2 & MAIN=3",
        "red_case_number != null",
      ],
      ...lawyerNames.map((lawyerName) => {
        const data = cancelData[lawyerName] || {
          all: [],
          waitLawsuit: [],
          withBackCase: [],
          withRedCase: [],
        };
        return [
          lawyerName,
          data.all.length,
          data.waitLawsuit.length,
          data.withBackCase.length,
          data.withRedCase.length,
        ];
      }),
    ];

    const option = {
      legend: {},

      toolbox: {
        show: true,
        feature: {
          saveAsImage: {},
        },
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
      },
      dataset: {
        source: chartData,
      },
      xAxis: { type: "category" },
      yAxis: { type: "value" },

      series: [
        {
          type: "bar",
          name: "ทั้งหมด",
          label: {
            show: true,
          },
          itemStyle: {
            color: "#3357FF",
            borderRadius: [20, 20, 0, 0],
          },
        },
        {
          type: "bar",
          name: "รอฟ้อง",
          label: {
            show: true,
          },
          itemStyle: {
            color: "red",
            borderRadius: [20, 20, 0, 0],
          },
        },
        {
          type: "bar",
          name: "มีวันนัดศาล",
          label: {
            show: true,
          },
          itemStyle: {
            color: "orange",
            borderRadius: [20, 20, 0, 0],
          },
        },
        {
          type: "bar",
          name: "พิพากษาแล้ว",
          stack: "response",
          label: {
            show: true,
          },
          itemStyle: {
            color: "#33FF57",
            borderRadius: [20, 20, 0, 0],
          },
        },
      ],
    };
    return (
      <ReactECharts
        option={option}
        style={{ height: 400, width: "100%" }}
        onEvents={{ click: onChartClick }}
      />
    );
  };

  const onChartClick = (params) => {
    const month = params.name; // เช่น "มี.ค."
    const data = cancelData[month]; // ดึงข้อมูลของเดือนนั้น

    setSelectedMonth(month);
    setSelectedData(data);
    preLoadContnos(data.all);
  };

  const preLoadContnos = (data) => {
    console.log("preLoadContnos", data);
    const preData = data
      .filter((item) => {
        return !item.red_case_number;
      })
      .map((item) => item.CONTNO); // ดึงเฉพาะ CONTNO
    const formattedData = preData.map((val) => `'${val}'`).join(",");
    setContnos({ CONTNO: formattedData });
    loadDataReport({ CONTNO: formattedData });
  };

  console.log(selectedData);

  // const createAndDownloadExcel = async () => {
  //   if (selectedData) {
  //     const workbook = new ExcelJS.Workbook();

  //     // วนลูปตามทนาย
  //     Object.entries(selectedData).forEach(([lawyerName, data]) => {
  //       const worksheet = workbook.addWorksheet(
  //         lawyerName === "all"
  //           ? "ทั้งหมด"
  //           : lawyerName === "waitLawsuit"
  //           ? "รอฟ้อง"
  //           : lawyerName === "withBackCase"
  //           ? "มีวันนัดศาล"
  //           : "พิพากษาแล้ว"
  //       );

  //       // 🔻 กำหนดคอลัมน์ รวมถึงวันนัดศาล และวันพิพากษา
  //       worksheet.columns = [
  //         { header: "ลำดับ", key: "no", width: 8 },
  //         { header: "เลขที่สัญญา", key: "contno", width: 20 },
  //         { header: "ชื่อลูกค้า", key: "customer_name", width: 30 },
  //         { header: "เลขคดีดำ", key: "black_case_number", width: 20 },
  //         { header: "วันนัดศาล", key: "consideration_date", width: 20 },
  //         { header: "ศาล", key: "provincial_court", width: 20 },
  //         {
  //           header: "เลขคดีแดง",
  //           key: "red_case_number",
  //           width: 20,
  //           color: { argb: "FF0000" },
  //           bold: true,
  //         },
  //         { header: "วันพิพากษา", key: "judge_date", width: 20 },
  //         { header: "สถานะ", key: "status", width: 15 },
  //       ];

  //       // 🔻 เพิ่มข้อมูล
  //       data.forEach((item, index) => {
  //         const row = worksheet.addRow({
  //           no: index + 1,
  //           contno: item.CONTNO || "-",
  //           customer_name: `${item.CUSTOMER_TNAME}${item.CUSTOMER_FNAME} ${item.CUSTOMER_LNAME}`,
  //           black_case_number: item.black_case_number || "-",
  //           consideration_date: item.consideration_date
  //             ? convertDateThaiShort(item.consideration_date)
  //             : "-",
  //           provincial_court: item.provincial_court || "-",
  //           red_case_number: item.red_case_number || "-",
  //           judge_date: item.judge_date
  //             ? convertDateThaiShort(item.judge_date)
  //             : "-",
  //           status: item.red_case_number
  //             ? "มีเลขคดีแดง"
  //             : item.consideration_date && item.black_case_number
  //             ? "นัดศาลแล้ว"
  //             : "รอฟ้อง",
  //         });

  //         // 🔻 สีตามสถานะ
  //         const statusCell = row.getCell("status");
  //         if (statusCell.value === "มีเลขคดีแดง") {
  //           statusCell.font = { color: { argb: "008000" }, bold: true }; // เขียว
  //         } else if (statusCell.value === "นัดศาลแล้ว") {
  //           statusCell.font = { color: { argb: "FFA500" }, bold: true }; // น้ำเงิน
  //         } else {
  //           statusCell.font = { color: { argb: "FF0000" }, bold: true }; // แดง
  //         }
  //         const redCaseNumberCell = row.getCell("red_case_number");
  //         redCaseNumberCell.font = { color: { argb: "FF0000" }, bold: true }; // แดง
  //       });

  //       // 🔻 สรุปท้ายตาราง
  //       worksheet.addRow([]);
  //       worksheet.addRow({
  //         judge_date: "รวมทั้งหมด:",
  //         status: selectedData.all.length,
  //       }).font = { bold: true };

  //       worksheet.addRow({
  //         judge_date: "รอฟ้อง:",
  //         status: selectedData.waitLawsuit.length,
  //       }).font = { bold: true, color: { argb: "FF0000" } };

  //       worksheet.addRow({
  //         judge_date: "นัดศาลแล้ว:",
  //         status: selectedData.withBackCase.length,
  //       }).font = { bold: true, color: { argb: "FFA500" } };

  //       worksheet.addRow({
  //         judge_date: "มีเลขคดีแดง:",
  //         status: selectedData.withRedCase.length,
  //       }).font = { bold: true, color: { argb: "008000" } };

  //       // 🔻 จัดกึ่งกลาง
  //       worksheet.eachRow((row) => {
  //         row.eachCell((cell) => {
  //           cell.alignment = { vertical: "middle", horizontal: "center" };
  //         });
  //       });
  //     });

  //     // 🔻 ดาวน์โหลดไฟล์
  //     const buffer = await workbook.xlsx.writeBuffer();
  //     const blob = new Blob([buffer], {
  //       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //     });
  //     saveAs(
  //       blob,
  //       `รายงาน_${selectedMonth}${dayjs().format("YYYY_MM_DD")}.xlsx`
  //     );
  //   } else {
  //     message.error("กรุณาเลือกข้อมูล");
  //   }
  // };

  const createAndDownloadExcel = async () => {
    if (selectedData) {
      const workbook = new ExcelJS.Workbook();

      // 📊 กำหนดชื่อ Sheet และสถานะ
      const sheetConfig = {
        all: "ทั้งหมด",
        waitLawsuit: "รอฟ้อง",
        withBackCase: "มีวันนัดศาล",
        withRedCase: "พิพากษาแล้ว",
        ageeement: "ยอมความ",
        finish: "จบคดี",
        withdrawCase: "ถอนคดี",
      };

      // วนลูปตามสถานะ
      Object.entries(selectedData).forEach(([key, data]) => {
        if (!data || data.length === 0) return; // ข้ามถ้าไม่มีข้อมูล

        const worksheet = workbook.addWorksheet(sheetConfig[key] || key);

        // 🔻 กำหนดคอลัมน์
        worksheet.columns = [
          { header: "ลำดับ", key: "no", width: 8 },
          { header: "เลขที่สัญญา", key: "contno", width: 20 },
          { header: "ชื่อลูกค้า", key: "customer_name", width: 35 },
          { header: "เลขคดีดำ", key: "black_case_number", width: 20 },
          { header: "วันนัดศาล", key: "consideration_date", width: 18 },
          { header: "ศาล", key: "provincial_court", width: 25 },
          { header: "เลขคดีแดง", key: "red_case_number", width: 20 },
          { header: "วันพิพากษา", key: "judge_date", width: 18 },
          { header: "สถานะหลัก", key: "main_status", width: 15 },
          { header: "สถานะคดี", key: "case_status", width: 15 },
        ];

        // 🔻 จัดรูปแบบ Header
        const headerRow = worksheet.getRow(1);
        headerRow.font = { bold: true, color: { argb: "FFFFFFFF" }, size: 12 };
        headerRow.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FF4472C4" },
        };
        headerRow.alignment = { vertical: "middle", horizontal: "center" };
        headerRow.height = 25;

        // 🔻 เพิ่มข้อมูล
        data.forEach((item, index) => {
          // กำหนดสถานะหลัก
          let mainStatus = "-";
          let mainStatusColor = "000000";

          if (item.MAIN_STATUS_ID === 11) {
            mainStatus = "จบคดี";
            mainStatusColor = "52C41A"; // เขียวเข้ม
          } else if (item.MAIN_STATUS_ID === 13) {
            mainStatus = "ถอนคดี";
            mainStatusColor = "FF4D4F"; // แดง
          } else if (item.MAIN_STATUS_ID === 5) {
            mainStatus = "ยอมความ";
            mainStatusColor = "87D068"; // เขียว
          }

          // กำหนดสถานะคดี
          let caseStatus = "-";
          let caseStatusColor = "000000";

          if (item.red_case_number) {
            caseStatus = "พิพากษาแล้ว";
            caseStatusColor = "4DFF88"; // เขียวอ่อน
          } else if (item.consideration_date && item.black_case_number) {
            caseStatus = "นัดศาลแล้ว";
            caseStatusColor = "FFB84D"; // ส้ม
          } else if (
            !item.black_case_number &&
            !item.consideration_date &&
            !item.red_case_number
          ) {
            caseStatus = "รอฟ้อง";
            caseStatusColor = "FFD699"; // เหลืองอ่อน
          }

          const row = worksheet.addRow({
            no: index + 1,
            contno: item.CONTNO || "-",
            customer_name: `${item.CUSTOMER_TNAME || ""}${
              item.CUSTOMER_FNAME || ""
            } ${item.CUSTOMER_LNAME || ""}`.trim(),
            black_case_number: item.black_case_number || "-",
            consideration_date: item.consideration_date
              ? convertDateThaiShort(item.consideration_date)
              : "-",
            provincial_court: item.provincial_court || "-",
            red_case_number: item.red_case_number || "-",
            judge_date: item.judge_date
              ? convertDateThaiShort(item.judge_date)
              : "-",
            main_status: mainStatus,
            case_status: caseStatus,
          });

          // 🔻 จัดสีตามสถานะ
          const mainStatusCell = row.getCell("main_status");
          mainStatusCell.font = {
            color: { argb: mainStatusColor },
            bold: true,
          };

          const caseStatusCell = row.getCell("case_status");
          caseStatusCell.font = {
            color: { argb: caseStatusColor },
            bold: true,
          };

          // สีแดงสำหรับเลขคดีแดง
          const redCaseCell = row.getCell("red_case_number");
          if (item.red_case_number) {
            redCaseCell.font = { color: { argb: "FF0000" }, bold: true };
          }

          // 🔻 เพิ่ม Border
          row.eachCell((cell) => {
            cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            };
            cell.alignment = { vertical: "middle", horizontal: "center" };
          });

          // สลับสีแถว
          if (index % 2 === 0) {
            row.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "FFF5F5F5" },
            };
          }
        });

        // 🔻 สรุปท้ายตาราง
        worksheet.addRow([]); // แถวว่าง

        // หัวข้อสรุป
        const summaryHeaderRow = worksheet.addRow({
          no: "",
          contno: "",
          customer_name: "",
          black_case_number: "",
          consideration_date: "",
          provincial_court: "",
          red_case_number: "📊 สรุปข้อมูล",
          judge_date: "",
          main_status: "จำนวน",
          case_status: "",
        });
        summaryHeaderRow.font = { bold: true, size: 12 };
        summaryHeaderRow.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFFEB9C" },
        };

        // สรุปแต่ละสถานะ
        const summaryData = [
          {
            label: "รวมทั้งหมด",
            count: selectedData.all?.length || 0,
            color: "3357FF",
          },
          {
            label: "รอฟ้อง",
            count: selectedData.waitLawsuit?.length || 0,
            color: "FFD699",
          },
          {
            label: "มีวันนัดศาล",
            count: selectedData.withBackCase?.length || 0,
            color: "FFB84D",
          },
          {
            label: "พิพากษาแล้ว",
            count: selectedData.withRedCase?.length || 0,
            color: "4DFF88",
          },
          {
            label: "ยอมความ",
            count: selectedData.ageeement?.length || 0,
            color: "87D068",
          },
          {
            label: "จบคดี",
            count: selectedData.finish?.length || 0,
            color: "52C41A",
          },
          {
            label: "ถอนคดี",
            count: selectedData.withdrawCase?.length || 0,
            color: "FF4D4F",
          },
        ];

        summaryData.forEach((item) => {
          const row = worksheet.addRow({
            no: "",
            contno: "",
            customer_name: "",
            black_case_number: "",
            consideration_date: "",
            provincial_court: "",
            red_case_number: item.label,
            judge_date: "",
            main_status: item.count,
            case_status: "",
          });
          row.font = { bold: true };
          row.getCell("main_status").font = {
            bold: true,
            color: { argb: item.color },
          };
        });
      });

      // 🔻 ดาวน์โหลดไฟล์
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(
        blob,
        `รายงานคดี_${selectedMonth}_${dayjs().format("YYYY_MM_DD_HHmm")}.xlsx`,
      );
    } else {
      message.error("กรุณาเลือกข้อมูล");
    }
  };

  const sumaryReportExcel = async () => {
    console.log("data", dataContnos);

    if (dataContnos) {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("สรุปรายการทั้งหมด");

      // 🔻 Group data by CONTNO prefix
      const grouped = {
        1: [],
        3: [],
        2: [],
        8: [],
      };

      dataContnos.forEach((item) => {
        const contno = item?.LOAN?.CONTNO || "";
        let groupKey = "8"; // default = สัญญา 8

        if (contno.startsWith("1-") || contno.startsWith("222")) {
          groupKey = "1";
        } else if (contno.startsWith("2-") || contno.startsWith("022")) {
          groupKey = "2";
        } else if (contno.startsWith("3-")) {
          groupKey = "3";
        }

        grouped[groupKey].push(item);
      });

      const groupNames = {
        1: "สัญญา 1",
        3: "สัญญา 3",
        2: "สัญญา 2",
        8: "สัญญา 8",
      };

      // Setup columns
      worksheet.columns = [
        { header: "ลำดับ", key: "no", width: 8 },
        { header: "ประเภท", key: "type", width: 15 },
        { header: "สาขา", key: "LOCAT", width: 10 },
        { header: "เลขที่สัญญา", key: "CONTNO", width: 15 },
        { header: "ชื่อลูกค้า", key: "cusName", width: 40 },
        { header: "ประเภท/จังหวัด", key: "DORECV", width: 15 },
        { header: "จังหวัด/ยี่ห้อ", key: "TYPE", width: 15 },
        { header: "เลข/ทะเบียน", key: "REGNO", width: 15 },
        { header: "ค่างวด", key: "TOT_UPAY", width: 15 },
        { header: "ค่างวดค้าง(โดยประมาณ)", key: "OverdueAmount", width: 20 },
        { header: "งวดที่ค้าง", key: "Overdue", width: 15 },
        { header: "ยอดหนี้", key: "NCSHPRC", width: 15 },
        { header: "ยอดหนี้รวมดอก", key: "TOTPRC", width: 15 },
        { header: "จ่ายมาทั้งหมด", key: "SMPAY", width: 15 },
        { header: "จ่ายล่าสุด", key: "LPAYD", width: 15 },
      ];

      let rowNumber = 1;
      let totalCount = 0;
      let totalTOT_UPAY = 0;
      let totalOverdueAmount = 0;
      let totalNCShPRC = 0;
      let totalTOTPRC = 0;
      let totalSMPAY = 0;

      // 🔻 เรียงข้อมูลตามลำดับ 1, 3, 2, 8
      const orderedKeys = ["1", "3", "2", "8"];

      orderedKeys.forEach((key) => {
        const groupData = grouped[key];

        if (groupData.length === 0) return;

        // เพิ่มแถวหัวข้อกลุ่ม
        const headerRow = worksheet.addRow({
          no: "",
          type: `${groupNames[key]} (${groupData.length} รายการ)`,
          LOCAT: "",
          CONTNO: "",
          cusName: "",
          DORECV: "",
          TYPE: "",
          REGNO: "",
          TOT_UPAY: "",
          OverdueAmount: "",
          Overdue: "",
          NCSHPRC: "",
          TOTPRC: "",
          SMPAY: "",
          LPAYD: "",
        });

        // จัดรูปแบบแถวหัวข้อ
        headerRow.font = { bold: true, color: { argb: "FFFFFFFF" } };
        headerRow.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FF4472C4" },
        };
        headerRow.alignment = { vertical: "middle", horizontal: "center" };

        // เพิ่มข้อมูลแต่ละรายการ
        groupData.forEach((item) => {
          const overdueAmount =
            (item?.LOAN?.EXP_TO - item?.LOAN?.EXP_FRM) * item?.LOAN?.TOT_UPAY;

          worksheet.addRow({
            no: rowNumber++,
            type: groupNames[key],
            LOCAT: item?.LOAN?.LOCAT || "-",
            CONTNO: item?.LOAN?.CONTNO || "-",
            cusName:
              (item?.CUSTOMER?.SNAM || "") +
              (item?.CUSTOMER?.NAME1 || "") +
              " " +
              (item?.CUSTOMER?.NAME2 || ""),
            DORECV:
              key === "1" ? item?.MORTGAGE?.COLOR : item?.MORTGAGE?.DORECV,
            TYPE: item?.MORTGAGE?.TYPE || "-",
            REGNO: key === "1" ? item?.MORTGAGE?.STRNO : item?.MORTGAGE?.REGNO,
            TOT_UPAY: currencyFormatComma(item?.LOAN?.TOT_UPAY),
            OverdueAmount: currencyFormatComma(overdueAmount),
            Overdue: item?.LOAN?.EXP_TO - item?.LOAN?.EXP_FRM,
            NCSHPRC: currencyFormatComma(item?.LOAN?.NCSHPRC),
            TOTPRC: currencyFormatComma(item?.LOAN?.TOTPRC),
            SMPAY: currencyFormatComma(item?.LOAN?.SMPAY),
            LPAYD: convertDateThaiShort(item?.LOAN?.LPAYD),
          });

          // รวมยอด
          totalCount++;
          totalTOT_UPAY += item?.LOAN?.TOT_UPAY || 0;
          totalOverdueAmount += overdueAmount || 0;
          totalNCShPRC += item?.LOAN?.NCSHPRC || 0;
          totalTOTPRC += item?.LOAN?.TOTPRC || 0;
          totalSMPAY += item?.LOAN?.SMPAY || 0;
        });

        // เพิ่มแถวว่างระหว่างกลุ่ม
        worksheet.addRow({});
      });

      // 🔻 เพิ่มแถวสรุปยอดรวม
      const summaryRow = worksheet.addRow({
        no: "",
        type: "รวมทั้งหมด",
        LOCAT: `${totalCount} รายการ`,
        CONTNO: "",
        cusName: `สัญญา 1: ${grouped["1"].length} | สัญญา 3: ${grouped["3"].length} | สัญญา 2: ${grouped["2"].length} | สัญญา 8: ${grouped["8"].length}`,
        DORECV: "",
        TYPE: "",
        REGNO: "",
        TOT_UPAY: currencyFormatComma(totalTOT_UPAY),
        OverdueAmount: currencyFormatComma(totalOverdueAmount),
        Overdue: "",
        NCSHPRC: currencyFormatComma(totalNCShPRC),
        TOTPRC: currencyFormatComma(totalTOTPRC),
        SMPAY: currencyFormatComma(totalSMPAY),
        LPAYD: "",
      });

      // จัดรูปแบบแถวสรุป
      summaryRow.font = { bold: true, size: 12 };
      summaryRow.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFFFEB9C" },
      };
      summaryRow.alignment = { vertical: "middle", horizontal: "center" };

      // จัดรูปแบบทุกเซลล์
      worksheet.eachRow((row, rowIndex) => {
        if (rowIndex === 1) {
          // Header row
          row.font = { bold: true };
          row.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFD9E1F2" },
          };
        }

        row.eachCell((cell) => {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
          cell.alignment = { vertical: "middle", horizontal: "center" };
        });
      });

      // 🔻 ดาวน์โหลดไฟล์
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(
        blob,
        `รายงาน_${selectedMonth}_${dayjs().format("YYYY_MM_DD")}.xlsx`,
      );
    } else {
      message.error("กรุณาเลือกข้อมูล");
    }
  };

  const handleData = (status) => {
    setStatusData(status);
    setIsModalCheckData(true);
  };

  const tagStyle = {
    fontSize: "16px",
    padding: "10px 16px",
    borderRadius: "10px",
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    fontWeight: "bold",
    cursor: "pointer",
    transform: isActive ? "scale(0.96)" : "scale(1)",
    boxShadow: isActive ? "inset 0 2px 5px rgba(0,0,0,0.2)" : "none",
    transition: "transform 0.1s ease, box-shadow 0.1s ease",
  };
  console.log("userCompany", userCompany);
  console.log("ROLE_ID", ROLE_ID);

  if (ROLE_ID === "4") {
    return <Card>ไม่มีสิทธ์เข้าถึงข้อมูล</Card>;
  } else {
    return (
      <>
        <Card>
          <Spin spinning={loading} size="large" tip=" Loading... ">
            <Row>
              {/* <Col span={12} style={{ textAlign: "start" }}>
              <b>บอกเลิกสัญญา</b>
              <DatePicker
                style={{ marginTop: "5px", marginLeft: "5px" }}
                onChange={onChange}
                picker="year"
                defaultValue={dayjs().startOf("year")}
                placeholder="โปรดเลือกปี"
              />
            </Col> */}
              <Col span={24} style={{ textAlign: "end" }}>
                {/* <Tooltip
                placement="bottom"
                title="คลิกเพื่อบันทึกสรุปรายงาน"
                arrow={mergedArrow}
              >
                <PrinterOutlined
                  style={{
                    fontSize: "40px",
                    color: "green",
                    cursor: "pointer",
                  }}
                  key="print"
                  onClick={() => {
                    createAndDownloadExcel();
                  }}
                />
              </Tooltip> */}
              </Col>
            </Row>
            {BarChart()}
            {selectedMonth && selectedData && (
              <>
                <Button
                  style={{
                    fontSize: "14px",
                    marginRight: "10px",
                    marginTop: "10px",
                    color: "blue",
                  }}
                  onClick={() => {
                    createAndDownloadExcel();
                  }}
                >
                  พิมพ์ port {selectedMonth}
                </Button>

                <Button
                  style={{
                    fontSize: "14px",
                    marginRight: "10px",
                    marginTop: "10px",
                    color: "green",
                  }}
                  onClick={() => {
                    sumaryReportExcel();
                  }}
                >
                  รายงานประชุม {selectedMonth}
                </Button>

                <div
                  style={{
                    marginTop: 24,
                    padding: "20px",
                    border: "1px solid #e0e0e0",
                    borderRadius: "16px",
                    background: "#f9f9f9",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
                  }}
                >
                  <h3
                    style={{
                      marginBottom: 20,
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                    }}
                  >
                    <BarChartOutlined
                      style={{ color: "#1890ff", fontSize: "20px" }}
                    />
                    รายละเอียดข้อมูล: <b>{selectedMonth}</b>
                  </h3>

                  {/* ส่วนที่ 1: สรุปข้อมูลทั้งหมด */}
                  <div style={{ marginBottom: 16 }}>
                    <Tag
                      color="#3357FF"
                      style={{
                        ...tagStyle,
                        color: "#fff",
                        fontSize: "16px",
                        padding: "8px 16px",
                      }}
                      onClick={() => handleData("all")}
                      className="clickable-tag"
                      onMouseDown={() => setIsActive(true)}
                      onMouseUp={() => setIsActive(false)}
                      onMouseLeave={() => setIsActive(false)}
                    >
                      <InboxOutlined /> ทั้งหมด:{" "}
                      {selectedData?.all?.length || 0} สัญญา
                    </Tag>
                  </div>

                  {/* ส่วนที่ 2: สถานะคดี */}
                  <div style={{ marginBottom: 12 }}>
                    <h4 style={{ marginBottom: 8, color: "#595959" }}>
                      📋 สถานะคดี
                    </h4>
                    <div
                      style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}
                    >
                      <Tag
                        color="#FFD699"
                        style={{ ...tagStyle, color: "#000" }}
                        onClick={() => handleData("waitLawsuit")}
                        className="clickable-tag"
                        onMouseDown={() => setIsActive(true)}
                        onMouseUp={() => setIsActive(false)}
                        onMouseLeave={() => setIsActive(false)}
                      >
                        <ClockCircleOutlined /> รอฟ้อง:{" "}
                        {selectedData?.waitLawsuit?.length || 0} สัญญา
                        {selectedData?.all?.length > 0 && (
                          <span
                            style={{
                              marginLeft: 4,
                              fontSize: "11px",
                              opacity: 0.8,
                            }}
                          >
                            (
                            {(
                              (selectedData?.waitLawsuit?.length /
                                selectedData?.all?.length) *
                              100
                            ).toFixed(1)}
                            %)
                          </span>
                        )}
                      </Tag>

                      <Tag
                        color="#FFB84D"
                        style={{ ...tagStyle, color: "#000" }}
                        onClick={() => handleData("withBackCase")}
                        className="clickable-tag"
                        onMouseDown={() => setIsActive(true)}
                        onMouseUp={() => setIsActive(false)}
                        onMouseLeave={() => setIsActive(false)}
                      >
                        <CalendarOutlined /> มีวันนัดศาล:{" "}
                        {selectedData?.withBackCase?.length || 0} สัญญา
                        {selectedData?.all?.length > 0 && (
                          <span
                            style={{
                              marginLeft: 4,
                              fontSize: "11px",
                              opacity: 0.8,
                            }}
                          >
                            (
                            {(
                              (selectedData?.withBackCase?.length /
                                selectedData?.all?.length) *
                              100
                            ).toFixed(1)}
                            %)
                          </span>
                        )}
                      </Tag>

                      <Tag
                        color="#4DFF88"
                        style={{ ...tagStyle, color: "#000" }}
                        onClick={() => handleData("withRedCase")}
                        className="clickable-tag"
                        onMouseDown={() => setIsActive(true)}
                        onMouseUp={() => setIsActive(false)}
                        onMouseLeave={() => setIsActive(false)}
                      >
                        <CheckCircleOutlined /> พิพากษาแล้ว:{" "}
                        {selectedData?.withRedCase?.length || 0} สัญญา
                        {selectedData?.all?.length > 0 && (
                          <span
                            style={{
                              marginLeft: 4,
                              fontSize: "11px",
                              opacity: 0.8,
                            }}
                          >
                            (
                            {(
                              (selectedData?.withRedCase?.length /
                                selectedData?.all?.length) *
                              100
                            ).toFixed(1)}
                            %)
                          </span>
                        )}
                      </Tag>

                      <Tag
                        color="#87D068"
                        style={{ ...tagStyle, color: "#fff" }}
                        onClick={() => handleData("ageeement")}
                        className="clickable-tag"
                        onMouseDown={() => setIsActive(true)}
                        onMouseUp={() => setIsActive(false)}
                        onMouseLeave={() => setIsActive(false)}
                      >
                        <FileProtectOutlined /> ยอมความ:{" "}
                        {selectedData?.ageeement?.length || 0} สัญญา
                        {selectedData?.all?.length > 0 && (
                          <span
                            style={{
                              marginLeft: 4,
                              fontSize: "11px",
                              opacity: 0.9,
                            }}
                          >
                            (
                            {(
                              (selectedData?.ageeement?.length /
                                selectedData?.all?.length) *
                              100
                            ).toFixed(1)}
                            %)
                          </span>
                        )}
                      </Tag>
                    </div>
                  </div>

                  {/* ส่วนที่ 3: สถานะเสร็จสิ้น */}
                  <div>
                    <h4 style={{ marginBottom: 8, color: "#595959" }}>
                      ✅ สถานะเสร็จสิ้น
                    </h4>
                    <div
                      style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}
                    >
                      <Tag
                        color="#52C41A"
                        style={{ ...tagStyle, color: "#fff", marginBottom: 8 }}
                        onClick={() => handleData("finish")}
                        className="clickable-tag"
                        onMouseDown={() => setIsActive(true)}
                        onMouseUp={() => setIsActive(false)}
                        onMouseLeave={() => setIsActive(false)}
                      >
                        <CheckOutlined /> จบคดี:{" "}
                        {selectedData?.finish?.length || 0} สัญญา
                        {selectedData?.all?.length > 0 && (
                          <span
                            style={{
                              marginLeft: 4,
                              fontSize: "11px",
                              opacity: 0.9,
                            }}
                          >
                            (
                            {(
                              (selectedData?.finish?.length /
                                selectedData?.all?.length) *
                              100
                            ).toFixed(1)}
                            %)
                          </span>
                        )}
                      </Tag>
                    </div>
                  </div>

                  <div>
                    <h4 style={{ marginBottom: 8, color: "#595959" }}>
                      <CloseCircleOutlined /> อื่น ๆ
                    </h4>
                    <div
                      style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}
                    >
                      <Tag
                        color="#FF4D4F"
                        style={{ ...tagStyle, color: "#fff" }}
                        onClick={() => handleData("withdrawCase")}
                        className="clickable-tag"
                        onMouseDown={() => setIsActive(true)}
                        onMouseUp={() => setIsActive(false)}
                        onMouseLeave={() => setIsActive(false)}
                      >
                        <CloseCircleOutlined /> ถอนคดี:{" "}
                        {selectedData?.withdrawCase?.length || 0} สัญญา
                        {selectedData?.all?.length > 0 && (
                          <span
                            style={{
                              marginLeft: 4,
                              fontSize: "11px",
                              opacity: 0.9,
                            }}
                          >
                            (
                            {(
                              (selectedData?.withdrawCase?.length /
                                selectedData?.all?.length) *
                              100
                            ).toFixed(1)}
                            %)
                          </span>
                        )}
                      </Tag>
                    </div>
                  </div>
                </div>
              </>
            )}
          </Spin>
        </Card>
        {isModalCheckData ? (
          <DataCheck
            open={isModalCheckData}
            close={setIsModalCheckData}
            data={selectedData}
            status={statusData}
          />
        ) : null}
      </>
    );
  }
};

const ReportLawsuit = MotionHoc(Main);
export default ReportLawsuit;
